import React, { useState } from 'react'
import { Tab, Form, Divider } from 'semantic-ui-react'
import useUser from '../../Shared/UserProvider/useUser'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { isProviderACompany, isProviderAPos } from '../../../services/Provider/Provider.service'
import { POSBrands } from './POSBrands'
import AdvancedFilters from '../../Home/AdvancedFilters'
import { getPointOfSale } from '../../../services/PointOfSale/PointOfSale.service'

const AdminPlatforms = () => {
    const {user} = useUser()
    const queryClient = useQueryClient()
    const [selectedPosId, setSelectedPosId] = useState((isProviderACompany(user.provider) || user.isLoggedInOwnScope) ?
      user.loginContext.providers.filter(isProviderAPos)[0]?.object.id :
      user.provider.object.id)

    const {data: selectedPos} = useQuery({
        queryKey: ['pointofsales', selectedPosId],
        queryFn: () => getPointOfSale(selectedPosId),
        enabled: !!selectedPosId,
    })

    const handleSelectedPosChange = (filters) => {
        queryClient.setQueryData(['pointofsales', filters.merchantId], filters.merchantId)
        setSelectedPosId(filters.merchantId)
    }

    return (
      <Tab.Pane>
          {(isProviderACompany(user.provider) || user.isLoggedInOwnScope) &&
            <Form>
                <AdvancedFilters
                  filters={{
                      merchantId: selectedPosId,
                  }}
                  debounceTimeInMs={0}
                  onFiltersChange={handleSelectedPosChange}
                >
                    <AdvancedFilters.PosFilter/>
                </AdvancedFilters>
                <Divider/>
            </Form>
          }
          {selectedPos && <POSBrands posId={selectedPos.id}/>}
      </Tab.Pane>
    )
}

export default AdminPlatforms
